import { render } from "./PromptEditHeader.vue?vue&type=template&id=4c8dc6ea"
import script from "./PromptEditHeader.vue?vue&type=script&lang=js"
export * from "./PromptEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__